/**
 * WithEpisodeSubscription
 *
 * 路由包装组件，从路由参数中提取剧集 ID 并传给 EpisodeSubscriptionProvider。
 * 支持 paramKey 属性指定路由参数键名（默认 'id'）。
 * 当剧集 ID 不存在时直接渲染 children（不订阅）。
 *
 * 需求：7.2、7.4
 *
 * 用法：
 * // episode-editor 路由
 * <WithEpisodeSubscription paramKey="id">
 *   <EpisodeEditorPage />
 * </WithEpisodeSubscription>
 *
 * // script-generation 路由
 * <WithEpisodeSubscription paramKey="episodeId">
 *   <ScriptGenerationPage />
 * </WithEpisodeSubscription>
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import EpisodeSubscriptionProvider from './EpisodeSubscriptionProvider';

interface WithEpisodeSubscriptionProps {
  /** 路由参数键名，默认 'id' */
  paramKey?: string;
  children: React.ReactNode;
}

const WithEpisodeSubscription: React.FC<WithEpisodeSubscriptionProps> = ({
  paramKey = 'episodeId',
  children,
}) => {
  const params = useParams<Record<string, string>>();
  const episodeId = params[paramKey];

  if (!episodeId) {
    // episodeId 不存在时直接渲染 children（不订阅）
    return <>{children}</>;
  }

  return (
    <EpisodeSubscriptionProvider episodeId={episodeId}>
      {children}
    </EpisodeSubscriptionProvider>
  );
};

export default WithEpisodeSubscription;
